import { getPrefix, getPrefixedSlug } from '~~/helpers/routes/prefixes';

export const usePrefix = () => {

  const route = useRoute();
  const languagePrefix = getPrefix(route.path);

  function addPrefixToSlugIfNecessary(slug: string): string;
  function addPrefixToSlugIfNecessary(slug: Maybe<string>): Maybe<string> {

    return getPrefixedSlug(slug, languagePrefix);
  
  };

  return {
    languagePrefix,
    addPrefixToSlugIfNecessary,
  };

};
